import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Footer from './Footer'
import Navbar from './Navbar'

export default function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm("service_jw3pqdd","template_p95kxrq", form.current,"v4LrLyUn_y3SxvPIr")
      .then((result) => {
          console.log(result.text);
          console.log("message sent successfully")
          var mail=document.getElementById("email")
          mail.reset()
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <div className='mail'>
      <Navbar/>
      <div className="flexrow2">
      <div className="flexcolumn2">
      I am on the lookout for oppurtunities which align with my line of interest and allows me to 
      delve deeper into them. If you have any such role in mind for which you think I may be a good fit, do let me know about it. Also, if you have any other questions
      or would just like to have a quick talk about my work (any feedback is appreciated), I am just a mail away.
      <div className='target'><i className="fa fa-envelope targeticon"><span className="targetext">jesmineakhter.work@gmail.com</span></i></div>
      <div className='target'><i className="fa fa-home targeticon" aria-hidden="true"><span className="targetext">Agartala, India</span></i></div>
      <div className='target'><i className="fa fa-map-marker targeticon" aria-hidden="true"><span className="targetext">Chennai, India</span></i></div>
     </div>
      <div className="flexcolumn2">
      <form ref={form} onSubmit={sendEmail} className="emailForm" id="email">
     <span className='mailinfo'>GET IN TOUCH?<br/></span>
      <input type="text" name="user_name" className="upper1" placeholder='Name'/>
      <input type="email" name="user_email" className="upper2" placeholder='Email'/>
      <input type="text" name="user_sub" className="lower" placeholder='Subject'/>
      <textarea name="message" placeholder='Message'/>
      <input type="submit" value="Send"/>
     </form>
     </div>
     </div>
      <Footer/>
    </div>
  )
}



    {/*<div className="flexrow mail">
      <div className="flexcolumn"> */}
 {/* <div className="flexcolumn">
      <div className="container mailanimation">
         <div className="envelope">
          <div className="paper"><span>Hope I can be of help to you!</span></div>
          <div className="inner1"></div>
          <div className="inner2"></div>
          <div className="outer"></div>
          <div className="outerp"></div>
        </div> 
      </div> 
      <span>@jesmineakhter.work@gmail.com</span>
      
      </div>
      </div> */}
